import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgentConfigsFormComponent } from './agent-configs-form.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { WorkingHoursModalModule } from './working-hours-modal/working-hours-modal.module';
import { SharedModule } from 'lib-trend-core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatSelectModule,
    WorkingHoursModalModule,
    SharedModule
  ],
  declarations: [
    AgentConfigsFormComponent
  ],
  exports: [
    AgentConfigsFormComponent
  ]
})
export class AgentConfigsFormModule { }
